// constants
import { PAYMENT_FALLBACK_TYPES } from "@payment-client/constants/PaymentFallback";

// types
import { CardDetails, PaymentFallbackMethod, PaymentAlertActionProps } from "@swiggy-private/payment-types";
import { CheckoutAction, CheckoutActionTypes, TransactionReqData } from "@swiggy-private/checkout-core";

// helper
import { getPaymentFallbackType } from "./PaymentFallbackHelper";

interface GetTransactionFallbackActionsParams {
    fallbackMethods: PaymentFallbackMethod[];
    payAction: (cardDetails: CardDetails, methodName: string, additionalParams: { [key: string]: string }) => void;
    setCheckoutState: React.Dispatch<CheckoutAction>;
    transactionReqData: TransactionReqData;
}

export const getTransactionFallbackActions = ({
    fallbackMethods,
    payAction,
    setCheckoutState,
    transactionReqData,
}: GetTransactionFallbackActionsParams): PaymentAlertActionProps[] => {
    return fallbackMethods.reduce<PaymentAlertActionProps[]>((fallbackActions, fallbackMethod) => {
        const paymentFallbackType = getPaymentFallbackType(fallbackMethod.paymentCode);

        switch (paymentFallbackType) {
            case PAYMENT_FALLBACK_TYPES.RETRY: {
                fallbackActions.push({
                    text: fallbackMethod.displayName,
                    onClick: (): void => {
                        payAction(
                            transactionReqData.cardDetails,
                            transactionReqData.paymentMethod,
                            transactionReqData.extraParams,
                        );
                    },
                });
                break;
            }

            case PAYMENT_FALLBACK_TYPES.DISMISS: {
                fallbackActions.push({
                    text: fallbackMethod.displayName,
                    onClick: (): void => {
                        setCheckoutState({ type: CheckoutActionTypes.SECURE_CARD });
                    },
                });
                break;
            }
            default:
                break;
        }
        return fallbackActions;
    }, []);
};
